import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import * as services from "../../../store/service";
import * as ProtectionPlanActions from "../../../store/protectionPlanService/ezs/actions";
import { useTranslation } from "react-i18next";
interface IProps {
    closeDialog: any;
    dialogId: string;
}

const SubscriptionChangeDialog: React.FunctionComponent<IProps> = (props) => {
    const dispatch = useDispatch();
    const checkContractChange = () => dispatch(ProtectionPlanActions.actionCreators.checkContractChange("contractChange", ""));
    const changedServices = useSelector((state: ApplicationState) => {
        return state.checkContractChangeState.contractChangeData;
    });
    const partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );
    const { t: tLang, i18n: i18nLang } = useTranslation();
    useEffect(() => {
        document.querySelector<any>(`[aria-labelledby=${props.dialogId}-title]`)!.classList.add("width-lg");
        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                props.closeDialog();
            }
        });
        return () => {
            window.removeEventListener("keyup", () => {});
        };
    });

    const sendAcknowledgement = () => {
        services.PostContractChangeReviewed().then((data: any) => {
            checkContractChange();
            props.closeDialog();
        });
    };

    return (
        <React.Fragment>
            <div className="dialog-header">
                <h1>{tLang("dashboard.subscriptionChange.header")}</h1>
            </div>

            <div className="dialog-body">
                <p>{tLang("dashboard.subscriptionChange.description")}</p>
                {changedServices != null ? (
                    <React.Fragment>
                        <ul className="list-reset">
                            {changedServices &&
                                changedServices.AddedServiceList &&
                                changedServices.AddedServiceList.map((srv: any, index: number) => (
                                    <li key={"service-add-" + index}>
                                        <em className="las la-check-circle inline-icon status-good"></em>
                                        <span className="subscription-changed-item">
                                            <h5>{srv.DisplayName}</h5>
                                        </span>
                                    </li>
                                ))}
                        </ul>

                        <ul className="list-reset">
                            {changedServices &&
                                changedServices.RemovedServiceList &&
                                changedServices.RemovedServiceList.map((srv: any, index: number) => (
                                    <li key={"service-remove-" + index}>
                                        <em className="las la-minus-circle inline-icon status-bad"></em>
                                        <span className="subscription-changed-item">
                                            <h5>{srv.DisplayName}</h5>
                                        </span>
                                    </li>
                                ))}
                        </ul>
                    </React.Fragment>
                ) : (
                    <div className="box loading"></div>
                )}

                <p>
                    {tLang("dashboard.subscriptionChange.call")} <a href={'tel:"' + partnerPhoneNumber + '"'}>{partnerPhoneNumber}</a>
                </p>
            </div>

            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button type="button" className="btn-default btn-primary" id="btn-subcription-changed-continue" onClick={() => sendAcknowledgement()}>
                            <span className="btn-text">{tLang("dashboard.subscriptionChange.continue")}</span>
                        </button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
export default SubscriptionChangeDialog;
